import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import { IVideoQuestionModelState, IVideoResponseValidation, VideoQuestionModelTypes } from './types'

const VideoQuestionModel: IQuestionModelConstructor<VideoQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<VideoQuestionModelTypes, IVideoQuestionModelState>({
    questionType: QuestionType.VIDEO,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IVideoQuestionModelState) {
  return [response.response]
}

function initState(state: IVideoQuestionModelState): IVideoQuestionModelState {
  state.response = { response: { id: state.questionSchema.id } }
  return state
}

function validateResponse({ response, questionSchema }: IVideoQuestionModelState): IVideoResponseValidation {
  return {
    valid: questionSchema.video ? ('file' == questionSchema.video_type ? response.viewed : true) : true
  }
}

export default VideoQuestionModel
